import { ACTIONS } from '../actions/products'
import { Image } from '@/typings/base'

export interface StockReducerState {
  loading?: boolean
  stock?: StockElement[]
  stockMap?: Map<string, StockElement>
  loadingBasket?: boolean
  stockBasket?: StockElement[]
  error?: any
}
//@TODO : reuse types
export interface StockElement {
  lizeeSKU?: string
  quantity?: number
  inStoreQuantity?: number
  warehouseQuantity?: number
  error?: string
  secondHand?: SecondHand[]
}

export interface SecondHand {
  quality?: string
  quantity?: number
  images?: Image[]
  reservedCount?: number
}

export const initialProductsState: StockReducerState = {
  loading: true,
  stock: [],
}

const stockReducer = (
  state = initialProductsState,
  action
): StockReducerState => {
  switch (action.type) {
    case ACTIONS.GET_STOCK_REQUEST:
      return { ...state, loading: true }
    case ACTIONS.GET_STOCK_BASKET_REQUEST:
      return { ...state, loadingBasket: true }
    case ACTIONS.NO_STOCK_REQUEST:
      return { ...state, loading: false }
    case ACTIONS.GET_STOCK_SUCCESS: {
      const currentStock = state.stock
      const incomingStock = action.stock
      const stockMap = new Map(
        currentStock.map((item) => [item.lizeeSKU, item])
      )
      // mix currentStock and incoming stock answer
      incomingStock.forEach((item) => {
        stockMap.set(item.lizeeSKU, item)
      })
      // Remove doublons
      const uniqueStock = Array.from(stockMap.values())
      return {
        ...state,
        loading: false,
        stock: uniqueStock,
        stockMap,
        error: undefined,
      }
    }
    case ACTIONS.GET_STOCK_BASKET_SUCCESS:
      return {
        ...state,
        loadingBasket: false,
        stockBasket: action.stockBasket,
        error: undefined,
      }
    case ACTIONS.GET_STOCK_FAILURE:
    case ACTIONS.GET_STOCK_BASKET_FAILURE:
      return { ...state, loading: false, error: action.err?.code }
    default:
      return state
  }
}

export default stockReducer
